import axios from 'axios';
import config from '../../../config';
import { getAuthToken } from '../../../utils/authStorage';

const authHeaders = () => {
  const token = getAuthToken();
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

/**
 * Download assessment PDF from server (draft, completed, or reviewed).
 */
export const downloadAssessmentPdf = async (assessmentId, { membershipId, assessmentDate } = {}) => {
  const response = await axios.get(
    `${config.apiBaseUrl}/hpc/admin/assessments/${assessmentId}/export/pdf`,
    {
      headers: authHeaders(),
      responseType: 'blob',
    }
  );

  const fallbackName = `HPC-Assessment-${membershipId || assessmentId}-${assessmentDate || 'report'}.pdf`;
  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename="?([^"]+)"?/i);
  const filename = match ? match[1] : fallbackName;

  const blob = new Blob([response.data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
